const mandDoclistItemText = {
  expiration: 'Días restantes'
};

export default mandDoclistItemText;
